import { routes } from '../../../common/contants/Routes';
import Overlay from './Overlay';

class Container {
  private static instance: Container | null = null;
  private container: HTMLIFrameElement | null = null;
  private companyId: string | null = null;
  private fadeOutTimeout: NodeJS.Timeout | null = null;
  private isAnimating = false;

  private constructor() {
    this.initialize();
  }

  public static getInstance(): Container {
    if (!Container.instance) {
      Container.instance = new Container();
    }
    return Container.instance;
  }

  private initialize(): void {
    const scriptElement = document.querySelector('script[gd-company-id]');
    this.companyId = scriptElement?.getAttribute('gd-company-id') || null;
    this.container = document.createElement('iframe');
    this.container.src = `https://app.getdemo.com.br${routes.GUIDE_PLAYER}/${this.companyId}`;
    this.container.style.setProperty('position', 'fixed');
    this.container.style.setProperty('border', 'none');
    this.container.style.setProperty('z-index', '9999999');
    this.container.style.setProperty('width', '0');
    this.container.style.setProperty('height', '0');
    this.container.style.setProperty('top', '0');
    this.container.style.setProperty('left', '0');
    this.container.style.setProperty('opacity', '0');
    this.container.style.setProperty('display', 'none');
    this.container.style.setProperty('transition', 'opacity 0.5s ease-in-out');

    this.setupListeners();
    document.body.appendChild(this.container);
  }

  private setupListeners(): void {
    if (!this.container) return;

    this.container.addEventListener('load', () => {
      this.sendSavedUserData();
    });
  }

  private sendSavedUserData(): void {
    const savedUserData = localStorage.getItem('getdemo_user');
    if (savedUserData) {
      try {
        const userData = JSON.parse(savedUserData);
        this.sendMessage({
          type: 'IDENTIFY_USER',
          userData
        });
      } catch (error) {
        console.error('Erro ao processar dados de usuário salvos:', error);
      }
    }
  }

  public sendMessage(message: any): void {
    if (this.container?.contentWindow) {
      this.container.contentWindow.postMessage(message, '*');
    }
  }

  public getContainer(): HTMLIFrameElement | null {
    return this.container;
  }

  public resizeAndPosition(
    position: { top: string; left: string },
    dimensions: { width: string; height: string },
    show?: boolean
  ): void {
    if (this.container) {
      this.container.style.setProperty('top', position.top);
      this.container.style.setProperty('left', position.left);
      this.container.style.setProperty('width', dimensions.width);
      this.container.style.setProperty('height', dimensions.height);
      if (show) {
        Overlay.getInstance().hide();
        this.show();
      }
    }
  }

  public show(): void {
    if (!this.container) return;

    if (this.fadeOutTimeout) {
      clearTimeout(this.fadeOutTimeout);
      this.fadeOutTimeout = null;
    }

    this.container.style.setProperty('display', 'block');

    if (!this.isAnimating) {
      this.isAnimating = true;

      this.container.style.setProperty('opacity', '0');

      this.container.offsetHeight;

      this.container.style.setProperty('opacity', '1');

      setTimeout(() => {
        this.isAnimating = false;
      }, 500);
    } else {
      this.container.style.setProperty('opacity', '1');
    }
  }

  public hide(): void {
    if (!this.container) return;

    if (this.fadeOutTimeout) {
      clearTimeout(this.fadeOutTimeout);
    }

    this.container.style.setProperty('opacity', '0');

    this.fadeOutTimeout = setTimeout(() => {
      if (this.container) {
        this.container.style.setProperty('display', 'none');
      }
      this.fadeOutTimeout = null;
    }, 500);
  }

  public destroy(): void {
    if (this.fadeOutTimeout) {
      clearTimeout(this.fadeOutTimeout);
      this.fadeOutTimeout = null;
    }

    if (this.container && document.body.contains(this.container)) {
      document.body.removeChild(this.container);
      this.container = null;
    }
    Container.instance = null;
  }

  public static destroy(): void {
    if (Container.instance) {
      Container.instance.destroy();
    }
  }
}

export default Container;
